<template>
	<div class="login-container" :style="{ backgroundImage: `url(${bgImage})` }">
		<div class="login-box">
			<div class="login-header">
				<h2>登录</h2>
				<p>欢迎回来</p>
			</div>
			<el-form
				ref="loginForm"
				:model="loginForm"
				:rules="loginRules"
				class="login-form"
				@submit.native.prevent="handleLogin"
			>
				<el-form-item prop="username">
					<el-input
						v-model="loginForm.username"
						placeholder="请输入用户名"
						prefix-icon="el-icon-user"
						clearable
						@keyup.enter.native="handleLogin"
					/>
				</el-form-item>
				<el-form-item prop="password">
					<el-input
						v-model="loginForm.password"
						type="password"
						placeholder="请输入密码"
						prefix-icon="el-icon-lock"
						show-password
						clearable
						@keyup.enter.native="handleLogin"
					/>
				</el-form-item>
				<el-form-item>
					<el-button
						:loading="loading"
						class="login-button"
						native-type="submit"
					>
						{{ loading ? '登录中...' : '登录' }}
					</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
import TokenManager from '@/utils/auth';
import { mapMutations } from 'vuex';
import bgImage from '@/assets/images/img0.jpg';

export default {
	name: 'Login',
	data() {
		return {
			loading: false,
			bgImage: bgImage,
			loginForm: {
				username: '',
				password: ''
			},
			loginRules: {
				username: [
					{ required: true, message: '请输入用户名', trigger: 'blur' },
					{ min: 3, max: 20, message: '用户名长度在 3 到 20 个字符', trigger: 'blur' }
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
				]
			}
		};
	},
	methods: {
		...mapMutations(['SET_USER_INFO']),
		// 处理登录
		handleLogin() {
			this.$refs.loginForm.validate(async (valid) => {
				if (!valid) {
					return false;
				}
				
				this.loading = true;
				// 调用登录API
				this.$post('/login', {
					username: this.loginForm.username,
					password: this.loginForm.password
				}).then(res => {
					// 保存token和用户信息
					if (res.data) {
						TokenManager.setTokenInfo({
							token: res.data.token || res.data.access_token,
							token_expires_at: res.data.token_expires_at || res.data.expires_at,
							user_id: res.data.user_id || res.data.userId,
							username: res.data.username || this.loginForm.username
						});

						// 保存用户信息到store
						// 确保 userId 字段正确映射，避免被 ...res.data 覆盖
						const userId = res.data.user_id || res.data.userId;
						const userInfo = {
							...res.data,
							userId: userId, // 确保 userId 字段存在（覆盖可能的 user_id）
							username: res.data.username || this.loginForm.username
						};
						this.SET_USER_INFO(userInfo);

						// 更新 store 中的 token
						this.$store.commit('SET_TOKEN', res.data.token || res.data.access_token);

						// 跳转到首页或重定向页面
						const redirect = this.$route.query.redirect || '/';
						// 避免重复导航错误
						if (this.$route.path !== redirect) {
							this.$router.push(redirect).catch(err => {
								// 忽略重复导航错误
								if (err.name !== 'NavigationDuplicated') {
									console.error('路由导航错误:', err);
								}
							});
						}
					} else {
						this.$message.error('登录失败，请检查用户名和密码');
					}
				}).catch(error => {
					console.error('登录错误:', error);
					this.$message.error(error.message || '登录失败，请检查网络连接');
				}).finally(() => {
					this.loading = false;
				});
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.login-container {
	width: 100%;
	height: 100vh;
	background-size: cover;
	background-position: center bottom;
	background-repeat: no-repeat;
	display: flex;
	justify-content: center;
	align-items: center;
}

.login-box {
	width: 400px;
	padding: 40px;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.login-header {
	text-align: center;
	margin-bottom: 30px;
}

.login-header h2 {
	margin: 0 0 10px 0;
	font-size: 28px;
	color: #333;
	font-weight: 600;
}

.login-header p {
	margin: 0;
	color: #999;
	font-size: 14px;
}

.login-form {
	margin-top: 20px;
}

.login-form .el-form-item {
	margin-bottom: 20px;
}

:deep(.el-input--suffix .el-input__inner) {
	padding-left: 25px;
	padding-right: 15px;
}

.login-button {
	width: 100%;
	font-size: 16px;
	margin-top: 30px;
	background-color: #fed408;
	color: #000000;
	border: none;
	border-radius: 4px;
	padding: 16px 16px;
	font-size: 14px;
	font-weight: 700;
	cursor: pointer;

	&:hover {
		background-color: #fed408;
		color: #000;
	}
}

@media (max-width: 480px) {
	.login-box {
		width: 90%;
		padding: 30px 20px;
	}
}
</style>

